import React from "react";
import './KontaktPage.scss';
import PinIcon from '../../assets/svg/pin.png'
import PhoneIcon from '../../assets/svg/phone.svg'
import EmailIcon from '../../assets/svg/email.png'

const KontaktPage: React.FC = () => {
    return (
        <div className="kontakt-container" id="scrollElement12">
            <h1 className="kontakt-page-title document-main-title">Lokacija</h1>
            <div className="kontakt-map-holder">
                <iframe width="100%" height="400" src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=sr&amp;q=Jove%20Ili%C4%87a%20154,%20Beograd+(Fakultet%20organizacionih%20nauka)&amp;t=&amp;z=16&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/collections/personal-trackers/">gps trackers</a></iframe>
                </div>
            <h1 className="kontakt-page-title document-main-title">Kontakt</h1>
            <div className="diagonal-holder">
                <div className="kontakt-info-holder">
                    <h2 className="kontakt-small-title">Udruženje Studenata Tehnike Evrope - BEST</h2>
                    <div className="kontakt-icon-text">
                        <img src={PinIcon} alt="Pin Icon" className="kontakt-icon"/>
                        <p className="kontakt-info-p">Karnegijeva 4, Beograd</p>
                    </div>
                    <div className="kontakt-icon-text">
                        <img src={PhoneIcon} alt="Phone Icon" className="kontakt-icon"/>
                        <p className="kontakt-info-p">+381 11 3370545</p>
                    </div>
                    <div className="kontakt-icon-text">
                        <img src={EmailIcon} alt="Email Icon" className="kontakt-icon"/>
                        <p className="kontakt-info-p">board@best.rs</p>
                    </div>
                </div>
                
            </div>
        </div>
    )
}

export default KontaktPage;